import { DatePicker } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import { ReportFilterKey, ReportFilterValue } from 'src/type/report';

type Props = {
  date: Dayjs | null;
  handleFilters: (name: ReportFilterKey, value: ReportFilterValue) => void;
};

export default function ReportDailyFilters({ date, handleFilters }: Props) {
  const handleSetDate = (startDate: Dayjs | null) => {
    const endDate = startDate;
    endDate?.add(1, 'day');
    handleFilters('startDate', startDate);
    handleFilters('endDate', endDate);
  };

  return (
    <DatePicker
      label="วันที่"
      value={date}
      onChange={handleSetDate}
      format="DD/MM/YYYY"
      slotProps={{
        textField: {
          fullWidth: true,
        },
      }}
    />
  );
}
